import { render, staticRenderFns } from "./DashboardContact.vue?vue&type=template&id=4875d26e&"
import script from "./DashboardContact.vue?vue&type=script&lang=js&"
export * from "./DashboardContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports